<template>
    <div>
        <app-header v-if="!isApp"></app-header>
        <router-view v-bind:class="{'is-app': isApp}" />
        <app-footer v-if="!isLocationChange && !isCalendarChange && !isApp && !car"></app-footer>
    </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
export default {
    name: 'BaseLayout',
    components: { AppHeader, AppFooter },
    computed: {
      isLocationChange() {
        return this.$store.getters.isLocationChange;
      },
      isCalendarChange() {
        return this.$store.getters.isCalendarChange;
      },
      isApp() {
        return this.$store.getters.isApp;
      },
      car() {
        return this.$store.getters.car;
      },
    },
}
</script>

<style>
  .content {
    min-height: calc(100vh - 121px);
  }
  @media screen and (max-width: 980px) {
    .content {
      min-height: calc(100vh - 184px);
    }
  }
  .is-app .rent-form__part {
    background-color: #F0F0F0;
  }
</style>
